import { useEffect, useRef } from 'react';

export function AmbientParticles() {
  return <div className="particles" aria-hidden="true">{Array.from({ length: 18 }, (_, i) => <i key={i} />)}</div>;
}

export function ScrollProgress() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let ticking = false;
    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      ref.current?.style.setProperty('--progress', String(max > 0 ? Math.min(window.scrollY / max, 1) : 0));
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div ref={ref} className="scroll-progress" aria-hidden="true"><i /></div>;
}

export function TiltCard({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const node = ref.current;
    if (!node || window.matchMedia('(pointer: coarse)').matches) return;
    const move = (event: PointerEvent) => {
      const rect = node.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      node.style.setProperty('--mx', `${x * 100}%`);
      node.style.setProperty('--my', `${y * 100}%`);
      node.style.setProperty('--rx', `${(0.5 - y) * 5}deg`);
      node.style.setProperty('--ry', `${(x - 0.5) * 7}deg`);
    };
    const leave = () => { node.style.setProperty('--rx', '0deg'); node.style.setProperty('--ry', '0deg'); };
    node.addEventListener('pointermove', move);
    node.addEventListener('pointerleave', leave);
    return () => { node.removeEventListener('pointermove', move); node.removeEventListener('pointerleave', leave); };
  }, []);
  return <div ref={ref} className={`tilt-card ${className}`}>{children}</div>;
}

export function SectionLabel({ index, children }: { index: string; children: React.ReactNode }) {
  return <div className="section-label"><span>{index}</span><b>{children}</b></div>;
}
